import React, { useEffect, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import type { SupportedLocale } from './index';

const LocaleContext = createContext<SupportedLocale>('en');

export const useLocale = () => useContext(LocaleContext);

export const LocaleProvider: React.FC<{
  locale: SupportedLocale;
  children: React.ReactNode;
}> = ({ locale, children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(locale);
    document.documentElement.lang = locale;
  }, [locale, i18n]);

  return (
    <LocaleContext.Provider value={locale}>
      {children}
    </LocaleContext.Provider>
  );
};
